import { forwardRef } from 'react';
import { IPageSection } from '../../types';
import { If } from '../../../Atoms/Conditionals';
import { handleTrack } from '../../../../utils/tracker';

const ChatFilingCard: React.FC<IPageSection> = forwardRef(
  (
    { id, postData, metaData },
    ref: React.ForwardedRef<HTMLDivElement>
  ): JSX.Element => {
    const whatsapp = postData?.chatfiling?.whatsapp?.trim() || '';
    const slack = postData?.chatfiling?.slack?.trim() || '';
    const teams = postData?.chatfiling?.teams?.trim() || '';
    const platforms = [
      postData?.chatfiling.whatsapp,
      postData?.chatfiling.slack,
      postData?.chatfiling.teams,
    ].filter(Boolean);
    const renderApps =
      postData?.chatfiling?.whatsapp ||
      postData?.chatfiling?.slack ||
      postData?.chatfiling?.teams;
    const singlePlatform = platforms.length === 1;
    return (
      <>
        {metaData && postData?.chatfiling.open_enable ? (
          <div id={id} ref={ref} className="wg-container pb-20">
            <div className="justify-between py-6 px-6 border border-purple-600 flex rounded-3xl relative mt-20 sm:block ">
              <div className="font-bold text-s-14 text-purple-400 absolute top-0 -translate-y-1/2 rounded-3xl bg-purple-600 px-4 py-2">
                Chat-Filing
              </div>
              <div className="w-1/2 felx flex-col justify-end sm:w-full">
                <div className="font-bold text-s-48 pb-2 sm:text-s-32">
                  File anytime, anywhere
                </div>
                <div className="font-medium text-s-20 text-gray-500 pb-6 sm:text-s-14 sm:text-[#9092A3] sm:font-medium">
                  No more app-switching or tab overload. Just chat to upload
                  docs, auto-fetch details, and get step-by-step filing — all in
                  one conversation.
                </div>
                <div className="flex justify-between sm:flex-wrap">
                  <div className="flex items-center gap-1 sm:text-s-14 sm:font-semibold ">
                    <img src="https://assets.clear.in/cleartax/images/1746953592_successtickcheckfill.svg" />
                    End-to-End Filing
                  </div>
                  <div className="flex items-center gap-1 sm:text-s-14 sm:font-semibold">
                    <img src="https://assets.clear.in/cleartax/images/1746953592_successtickcheckfill.svg" />
                    Smart Automation
                  </div>
                  <div className="flex items-center gap-1 sm:text-s-14  sm:font-semibold">
                    <img src="https://assets.clear.in/cleartax/images/1746953592_successtickcheckfill.svg" />
                    Guided Process
                  </div>
                </div>
              </div>
              {renderApps ? (
                <div className="font-bold text-s-20 bg-purple-600 rounded-2xl pt-7 px-6 sm:mt-8">
                  <div className="text-center pb-8">
                    Select your platform to get started
                  </div>

                  <div
                    className={`flex gap-4 pb-7 sm:gap-3 ${
                      singlePlatform ? 'justify-center' : 'justify-center'
                    }`}
                  >
                    <If condition={!!whatsapp}>
                      <a
                        href={whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block"
                        onClick={(e) => {
                          handleTrack({
                            label: 'chat_filing_whatsapp',
                            obj: e.target,
                          });
                        }}
                      >
                        <div className="flex flex-col bg-white rounded-2xl shadow-xl justify-between hover:shadow-2xl transition-shadow duration-200 h-32 w-31 sm:h-20 sm:w-auto">
                          <img
                            src="https://assets.clear.in/cleartax/images/1746954075_image468.svg"
                            className="px-8 py-3 sm:p-0 sm:h-8 sm:w-22 sm:mt-3"
                          />
                          <div
                            className="text-s-14 font-semibold text-[#314259] text-center px-4 
                           sm:text-s-12"
                          >
                            WhatsApp
                          </div>
                          <div className="text-s-12 text-[#6B7280] pb-2 text-center sm:text-s-10">
                            (@8951262134)
                          </div>
                        </div>
                      </a>
                    </If>

                    <If condition={!!slack}>
                      <a
                        href={slack}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block"
                        onClick={(e) => {
                          handleTrack({
                            label: 'chat_filing_slack',
                            obj: e.target,
                          });
                        }}
                      >
                        <div className="flex flex-col bg-white rounded-2xl shadow-xl justify-between hover:shadow-2xl transition-shadow duration-200 h-32 w-31 sm:h-20 sm:w-[91px]">
                          <img
                            src="https://assets.clear.in/cleartax/images/1746954562_image469.svg"
                            className="px-8 py-4 sm:p-0 sm:h-8 sm:w-22 sm:mt-3"
                          />
                          <div className="text-s-14 font-semibold text-[#314259] text-center px-4 pb-3 sm:text-s-12">
                            Slack
                          </div>
                        </div>
                      </a>
                    </If>

                    <If condition={!!teams}>
                      <a
                        href={teams}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block"
                        onClick={(e) => {
                          handleTrack({
                            label: 'chat_filing_teams',
                            obj: e.target,
                          });
                        }}
                      >
                        <div className="flex flex-col bg-white rounded-2xl shadow-xl justify-between hover:shadow-2xl transition-shadow duration-200 h-32 w-31 sm:h-20 sm:w-[91px]">
                          <img
                            src="https://assets.clear.in/cleartax/images/1746954588_image470.svg"
                            className="px-8 py-4 sm:p-0 sm:h-8 sm:w-22 sm:mt-3"
                          />
                          <div className="text-s-14 font-semibold text-[#314259] text-center px-4 pb-3 sm:text-s-12">
                            Teams
                          </div>
                        </div>
                      </a>
                    </If>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </>
    );
  }
);
ChatFilingCard.displayName = 'ChatFilingCard';

export default ChatFilingCard;
